import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["output", "source", "delimiter"];

    changeDelimiter(e) {
        // the source delimiter used here is #delim#. 
        this.outputTarget.value = this.sourceTarget.value.replace(new RegExp("#delim#", "gi"), `${this.delimiterTarget.value}`) 
    }
  }